import React from "react";
import {RootContext} from '../providers';

function useRoot() {
    return React.useContext(RootContext);
}

export {useRoot}
